// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const FontOptionsIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="FontOptionsIcon" ref={forwardedRef} {...props}>
      <path d="m4.852 14.35 4.176-12.6h1.998l4.14 12.6h-1.764l-.954-3.042H7.534l-.99 3.042zM8.02 9.796h3.96l-1.944-6.21z" />
      <path d="M8.5 15.85H4v1.5h4.5z" />
      <path d="M11.5 17.35H16v-1.5h-4.5V14.6H10v4h1.5z" />
    </SvgIcon>
  );
});

/**
 * Use to give different font options like switching between DT Flow and Mono
 * @public
 */
export const FontOptionsIcon = /* @__PURE__ */ Object.assign(
  FontOptionsIconComponent,
  { displayName: 'FontOptionsIcon' },
);
